import { FaFacebook, FaYoutube, FaInstagram } from "react-icons/fa";
import { PiThreadsLogoBold } from "react-icons/pi";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-16 px-10">
      <div className="container px-6 md:pl-16 pr-6 grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Left Section */}
        <div>
          <h2 className="text-2xl font-bold">Enso</h2>
          <p className="text-base mt-6 max-w-xs">
            Enso symbolize a moment when the mind is<br />
            free to simply let the body/spirit create.<br />
          </p>
          <div className="flex space-x-4 mt-8">
            <div className="bg-gray-700 p-4 rounded-full">
              <FaFacebook className="text-3xl cursor-pointer hover:text-blue-500" />
            </div>
            <div className="bg-gray-700 p-4 rounded-full">
              <FaYoutube className="text-3xl cursor-pointer hover:text-red-500" />
            </div>
            <div className="bg-gray-700 p-4 rounded-full">
              <PiThreadsLogoBold className="text-3xl cursor-pointer hover:text-gray-400" />
            </div>
            <div className="bg-gray-700 p-4 rounded-full">
              <FaInstagram className="text-3xl cursor-pointer hover:text-pink-500" />
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div>
          <h2 className="text-2xl font-bold">Contact</h2>
          <p className="text-base mt-6">
            <a href="tel:++919967606321" className="hover:text-gray-300">+91 99676 06321</a>
          </p>
          <p className="text-base mt-4">
            <a href="https://www.ensophotography.in" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">www.ensophotography.in</a>
          </p>
          <p className="text-base mt-6">
            <a href="mailto:Enso.photography.design@gmail.com" className="hover:text-gray-300">Enso.photography.design@gmail.com</a>
          </p>
          <p className="text-base mt-6">
            A1 112, VIDA COMPLEX ABOVE KFC, PANJIM <br />
            PONDA ROAD, KADAMBA PLATEAU, GOA 403206
          </p>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-gray-700 my-10" />

      {/* Bottom Section */}
      <div className="container px-6 md:pl-16 pr-6 flex flex-col md:flex-row justify-between text-base text-gray-400 text-center md:text-left">
        <p>Copyright &copy; 2025 Enso. All Rights Reserved</p>
        <div className="flex justify-center md:justify-start space-x-4 mt-6 md:mt-0">
          <a href="#" className="hover:text-white">User Terms & Conditions</a>
          <span>|</span>
          <a href="#" className="hover:text-white">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
